(function () {
	const swiperInstances = new Map();

	const addClasses = (slider) => {
		const sliderWrapper = slider.querySelector(".blog__posts-wrapper");
		const slides = slider.querySelectorAll(".blog__post");

		slider.classList.add("swiper");
		if (sliderWrapper) sliderWrapper.classList.add("swiper-wrapper");

		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});
	};

	const initSlider = (section) => {
		const slider = section.querySelector(".swiper--articles");

		if (!slider || swiperInstances.has(slider)) return;

		addClasses(slider);

		const numberColumns = Number(slider.dataset.columnsMobile || 1);

		const swiper = new Swiper(slider, {
			loop: false,
			speed: 800,
			mousewheel: {
				forceToAxis: true,
			},
			navigation: {
				nextEl: slider.querySelector(".blog__nav-next"),
				prevEl: slider.querySelector(".blog__nav-prev"),
			},
			pagination: {
				el: slider.querySelector(".blog__nav-pagination"),
				clickable: true,
				type: "custom",
				renderCustom: function (swiper, current, total) {
					let out = "";

					for (let i = 1; i <= total; i++) {
						out += `<span class="swiper-pagination-bullet ${i === current ? "swiper-pagination-bullet-active" : ""
							}" tabindex="0" role="button" aria-label="Go to slide ${i}"></span>`;
					}

					return out;
				},
			},
			breakpoints: {
				320: {
					slidesPerView: numberColumns,
					slidesPerGroup: numberColumns,
					spaceBetween: 8,
				},
				750: {
					slidesPerView: 2,
					slidesPerGroup: 2,
					spaceBetween: 16,
				},
				990: {
					slidesPerView: 3,
					slidesPerGroup: 1,
					spaceBetween: 20,
				},
				1200: {
					slidesPerView: 4,
					slidesPerGroup: 1,
					spaceBetween: 24,
				},
			},
		});

		swiperInstances.set(slider, swiper);
	};

	const initSection = (section) => {
		if (section && section.classList.contains("section-featured-blog")) {
			initSlider(section);
		}
	};

	initSection(document.currentScript.parentElement);

	document.addEventListener("shopify:section:load", function (event) {
		initSection(event.target);
	});
})();